export enum IresClientType {
  SanTec = "Santec",
  Other = "Other",
}

export function getIresClientType(clientId: string): IresClientType {
  switch (clientId) {
    case "0enZIb5pzEVFdawo33jDyMz9V8C2": // Test SanTec client
    case "ihTNLIk4GSfP5JkSSV6BDqVptCu2": // Actual SanTec client
      return IresClientType.SanTec;
    default:
      return IresClientType.Other;
  }
}
